module.exports = __webpack_public_path__ + "img/hr-tank-base-shadow-1.438ae2d8.png";